/**
 * WebSocket URL for Colyseus (colyseus.js Client).
 * Порт: `REACT_APP_COLYSEUS_URL` (полный URL) или `REACT_APP_COLYSEUS_PORT` (по умолчанию 3334).
 * Скрипт `scripts/start-dev-online.ps1` пишет свободный порт в `client/.env.development.local`.
 */
function colyseusPort() {
  const fromEnv = process.env.REACT_APP_COLYSEUS_PORT;
  if (typeof fromEnv === 'string' && /^\d+$/.test(fromEnv.trim())) return fromEnv.trim();
  return '3334';
}

export function getColyseusWsUrl() {
  if (process.env.REACT_APP_COLYSEUS_URL) return process.env.REACT_APP_COLYSEUS_URL;
  const port = colyseusPort();
  if (process.env.NODE_ENV === 'production') {
    if (typeof window === 'undefined') return `ws://localhost:${port}`;
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    return `${protocol}://${window.location.hostname}:${port}`;
  }
  if (typeof window === 'undefined') return `ws://localhost:${port}`;
  const isLocalhost =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  if (isLocalhost) return `ws://localhost:${port}`;
  return `ws://${window.location.hostname}:${port}`;
}
